module.exports = __webpack_public_path__ + "img/lightning.4e0de0f8.png";